import { MultiService } from 'modules/api/MultiService';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { web3Api } from 'store/queries';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';

export const fetchIsDevdaoAccountFallback = false;

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be refelected there as well.
export const {
  endpoints: { fetchIsDevdaoAccount },
  useFetchIsDevdaoAccountQuery,
  useLazyFetchIsDevdaoAccountQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchIsDevdaoAccount: build.query<boolean, void>({
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async () => {
          const api = MultiService.getService().getAccountingGateway();

          const { is_participant: isParticipant } =
            await api.checkDevdaoInstantJwtParticipant();

          return { data: isParticipant };
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  selectDataWithFallbackCachedByParams: selectIsDevdaoAccount,
  selectLoadingCachedByParams: selectIsDevdaoAccountLoading,
  selectStateCachedByParams: selectIsDevdaoAccountState,
} = createQuerySelectors({
  endpoint: fetchIsDevdaoAccount,
  fallback: fetchIsDevdaoAccountFallback,
});
